<template>
  <div>
    <template v-if="isEditMode">
      <MoneyInput
        :label="question"
        :currencySymbol="currencySymbol"
        :currencyCode="currency"
        :period="period"
        :value="value"
        :disabled="disabled"
        :tourId="tourId"
        @onInput="onInput"
        @onBlur="$emit('onBlur')"
      />
      <p
        v-if="isDifferentCurrency() && value > 0"
        class="label grey--text ma-0 pa-0"
        datatid="money-question-exchange"
      >
        <span>{{ organizationCurrencySymbol }}</span>
        <span>{{ exchangeValue.toLocaleString(navigator.language) }}</span>
        <span> {{ organizationCurrency }}</span>
      </p>
    </template>

    <div v-else class="d-flex flex-column align-start">
      <FieldLabel :text="question" :disabled="disabled" />
      <p v-if="isImpactValidated" class="text-body-1 ma-0 pa-0">
        -
      </p>
      <v-chip v-else disabled small class="mt-2 label">{{
        $t('common.in_progress_status')
      }}</v-chip>
    </div>
  </div>
</template>

<script>
import MoneyInput from '@/components/Rev/Review/MoneyInput.vue'
import FieldLabel from '@/components/Core/FieldLabel'

export default {
  name: 'MoneyQuestion',

  props: {
    value: {
      type: Number,
      required: false,
    },
    question: {
      type: String,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    organizationCurrency: {
      type: String,
      required: false,
    },
    currencySymbol: {
      type: String,
      required: true,
    },
    organizationCurrencySymbol: {
      type: String,
      required: false,
    },
    period: {
      type: String,
      required: false,
    },
    exchangeRate: {
      type: Number,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isEditMode: {
      type: Boolean,
      default: true,
    },
    tourId: {
      type: String,
      required: false,
    },
    isImpactValidated: Boolean,
  },

  components: {
    MoneyInput,
    FieldLabel,
  },

  data() {
    return {
      exchangeValue: this.getExchangedValue(this.value),
    }
  },

  methods: {
    isDifferentCurrency: function() {
      return this.organizationCurrency !== this.currency
    },

    onInput: function(inputValue) {
      this.exchangeValue = this.getExchangedValue(inputValue)
      this.$emit('input', inputValue)
    },

    getExchangedValue: function(value) {
      return Math.round(parseInt(value) / this.exchangeRate)
    },
  },
}
</script>
